

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './Header/Header';
import Footer from './Footer/Footer';
import About from './pages/about';
import OurWork from './pages/OurWork';
import Epco from './pages/epco';
import Fpo from './pages/fpo';
import Ourstory from './pages/ourstory';
import Founder from './pages/founder';
import Ourpartner from './pages/Ourpartner';
import Whatwedo from './pages/whatwedo';
import Resorce from './pages/annualreports';
import Contact from './pages/contact';
import Gallery from './pages/gallery';
import Home from './pages/index';
import Service from './pages/Service';
import Donation from './pages/donation';
import Annualreports from './pages/annualreports';
import Financialreports from './pages/financialreports';


import ScrollToTop from './ScrollToTop'; // Import your ScrollToTop component

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop /> {/* Add this line */}
        <Header /> 
        <Routes> 
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/OurWork" element={<OurWork />} />
          <Route path="/epco" element={<Epco />} /> 
          <Route path="/fpo" element={<Fpo />} /> 
          <Route path="/ourstory" element={<Ourstory />} />
          <Route path="/founder" element={<Founder />} />
          <Route path="/Ourpartner" element={<Ourpartner />} />
          <Route path="/whatwedo" element={<Whatwedo />} />
          <Route path="/resorce" element={<Resorce />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/service" element={<Service/>} />
          <Route path="/donation" element={<Donation/>} />
          <Route path="/annualreports" element={<Annualreports/>} />
          <Route path="/financialreports" element={<Financialreports/>} />
     
        </Routes>
        <Footer /> 
      </BrowserRouter>
    </div>
  );
}

export default App;

